<template>
  <div class="yc-upload">
      <el-upload
        :action="url"
        :disabled="disabled"
        :accept="acceptStr"
        :limit="limit"
        :list-type="listType"
        :multiple="multiple"
        :show-file-list="showFileList"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-exceed="uploadExceed"
        :style="upStyle">
            <slot>
                <el-button :disabled="disabled" size="small" type="primary">上传文件</el-button>
            </slot>
        </el-upload>
        <div class="upload-tip">
            <slot name="tip"></slot>
        </div>
  </div>
</template>

<script>
import {upFileTypes} from '@/server/common-codes.js'

export default {
    name: 'vUploadFile',
    props: {
        // '/file/upload/image' | '/file/upload/file'
        url:{
            type: String,
            default: global.upUrl + '/file/upload/file'
        },
        // img | file | allfile
        upType:{
            type: String,
            default: 'allfile'
        },
        disabled: Boolean,
        limit: Number,
        accept: String,
        multiple: Boolean,
        showFileList: Boolean,
        //--text / picture / picture-card
        listType: {
            type: String,
            default: 'text'
        },
        upSuccess: Function,
        upError: Function,
        upExceed: Function,
        upStyle: Object
    },
    data(){
        return {
            acceptStr: this.accept || upFileTypes[this.upType],
        }
    },
    methods:{
        uploadSuccess(...props){
            if(props[0].success) {
                this.$elMsg({
                    type: 'success',
                    message: '文件上传成功!'
                });
                if(this.upSuccess) {
                    this.upSuccess(...props)
                }
            } else {
                this.$elMsg({
                    type: 'error',
                    message: props[0].message || '上传文件为空!'
                });
            }
        },
        uploadError(...props){
            if(this.upError) {
                this.upError(...props)
            } else {
                this.$elMsg({
                    type: 'error',
                    message: err.data.msg || '文件上传失败!'
                });
            }
        },
        uploadExceed(...props){
            if(this.upExceed) {
                this.upExceed(...props)
            } else {
                this.$alert('已超出上传数量限制！', '提示', {
                    confirmButtonText: '确定'
                });
            }
        }
    }
}
</script>
<style scoped>
.yc-upload >>> .el-upload--picture-card{
    width: 100%;
    height: 100%;
    line-height: 0;
    overflow: hidden;
    vertical-align: middle;
}

.yc-upload >>> .el-upload--picture-card img{
    width: 100%;
    height: 100%;
}
</style>
<style lang="less" scoped>
.yc-upload{
    display: inline-block;
    .upload-tip{
        font-size: 12px;
        color: #606266;
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/uploadFile.vue